import { checkinApi } from '@/services/api/httpClient';

const trackingActions = {
  async removePacientFromTracking({ getters, commit }, params) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/admission/${admissionId}/remove-collect-queue`;
    try {
      const resp = await checkinApi().get(url);

      return resp.data;
    } catch (error) {
      throw new Error(error);
    }
  },

  async includePatientToPriorityQueue({ getters }) {
    const { id: admissionId, status } = getters.getCurrentAdmissionState.data;

    const url = `/admission/${admissionId}/priority-collect-queue`;

    if (status === 'CHECK_IN_DONE') {
      try {
        const resp = await checkinApi().patch(url);

        return resp.data;
      } catch (error) {
        return null;
      }
    }

    return null;
  },
};

export default trackingActions;
